import type { OptionsDocument } from 'paintscout'
import type { EventTypeOption } from '..'

export function getEventTypes(args: {
  options: OptionsDocument
  includeDeleted?: boolean
  includeProduction?: boolean
  onlyProduction?: boolean
}): EventTypeOption[] {
  const { options, includeDeleted = false, includeProduction = false, onlyProduction = false } = args
  const { eventTypes } = options.options

  if (!eventTypes) {
    return []
  }

  return eventTypes.order
    .map((orderItem) => {
      const eventType = eventTypes.values[orderItem]
      if (
        !eventType ||
        (!includeDeleted && eventType.deleted) ||
        (onlyProduction && !eventType.production) ||
        (!(includeProduction || onlyProduction) && eventType.production)
      ) {
        return null
      }
      return eventType
    })
    .filter(Boolean)
}
